import api from './api';
import { nullableUuid } from '@/utils/uuid';

export type PerfilModulo = 'BLOQUEADO' | 'CONSULTA' | 'COMPLETO' | 'EMISSAO';

export interface Usuario {
  id: string;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  company_id?: string | null;
  phone?: string | null;
  cpf?: string | null;
  cargo?: string | null;
  departamento?: string | null;
  is_admin: boolean;
  is_company_admin: boolean;
  is_manager: boolean;
  is_supervisor: boolean;
  is_operator: boolean;
  is_contador: boolean;
  is_active: boolean;
  perfil_industrializacao?: string | null;
  sped_perfil?: PerfilModulo | null;
  dfe_perfil?: PerfilModulo | null;
}

export interface UsuarioInput {
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  company_id?: string | null;
  phone?: string | null;
  cpf?: string | null;
  cargo?: string | null;
  departamento?: string | null;
  is_admin?: boolean;
  is_company_admin?: boolean;
  is_manager?: boolean;
  is_supervisor?: boolean;
  is_operator?: boolean;
  is_contador?: boolean;
  is_active?: boolean;
  sped_perfil?: PerfilModulo | null;
  dfe_perfil?: PerfilModulo | null;
  password?: string;
  password_confirm?: string;
}

const ENDPOINT = '/users';

const usuarioService = {
  async listar(): Promise<Usuario[]> {
    const response = await api.get<Usuario[]>(ENDPOINT);
    return response.data;
  },
  async buscarPorId(id: string): Promise<Usuario> {
    const response = await api.get<Usuario>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: UsuarioInput): Promise<Usuario> {
    const response = await api.post<Usuario>(ENDPOINT, { ...data, company_id: nullableUuid(data.company_id) });
    return response.data;
  },
  async atualizar(id: string, data: Partial<UsuarioInput>): Promise<Usuario> {
    const payload = data.company_id === undefined ? data : { ...data, company_id: nullableUuid(data.company_id) };
    const response = await api.put<Usuario>(`${ENDPOINT}/${id}`, payload);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
  async resetarSenha(id: string, novaSenha: string): Promise<{ message: string }> {
    const response = await api.post(`${ENDPOINT}/${id}/reset_password`, { nova_senha: novaSenha });
    return response.data;
  },
  async alternarStatus(id: string): Promise<{ message: string; is_active: boolean }> {
    const response = await api.post(`${ENDPOINT}/${id}/toggle_status`);
    return response.data;
  },
};

export default usuarioService;
